export default __webpack_public_path__ + "static/media/Icon-Complete.37106d8f.svg";